<template>
  <component
    :is="componentType"
    :is-disabled="isDisabled"
    @key-click="onKeyClick"
    @go-back="$emit('go-back')"
    @close="$emit('close')"
  />
</template>

<script lang="ts">
import { Component } from 'vue';
import { defineComponent, PropType } from 'vue-demi';

import AppDialerKeypadPopup from '../../components/popups/AppDialerKeypadPopup.vue';
import AppDialerKeypadPage from '../../components/pages/AppDialerKeypadPage.vue';
import { useDialerActions } from '../../composables';

export default defineComponent({
  name: 'AppDialerKeypadContainer',
  components: {
    AppDialerKeypadPage,
  },
  props: {
    component: {
      type: String as PropType<'popup' | 'page'>,
      default: '',
    },
  },
  emits: ['go-back', 'close'],
  setup() {
    const { playDTMF } = useDialerActions();
    return { playDTMF };
  },
  data() {
    return {
      isDisabled: false,
    };
  },
  computed: {
    componentType(): Component {
      switch (this.component) {
        case 'page':
          return AppDialerKeypadPage;
        case 'popup':
        default:
          return AppDialerKeypadPopup;
      }
    },
  },
  methods: {
    async onKeyClick(key: string) {
      this.isDisabled = true;
      await this.playDTMF(key);
      this.isDisabled = false;
    },
  },
});
</script>
